import axios from 'axios';

const API_DOMAIN =
  window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN || 'http://localhost:3001';

export interface PostEvidencesBulkParams {
  evidenceIds: string[];
  page?: number;
  pageSize?: number;
}

export interface EvidencesBulkResponse {
  evidences: Record<string, unknown>[];
  total: number;
  page: number;
  pageSize: number;
  hasMore: boolean;
}

export async function postEvidencesBulk(
  params: PostEvidencesBulkParams,
  auth0: { getAccessTokenSilently: () => Promise<string> }
): Promise<EvidencesBulkResponse> {
  const response = await axios.post<EvidencesBulkResponse>(
    `${API_DOMAIN}/evidences/bulk`,
    {
      evidenceIds: params.evidenceIds,
      page: params.page ?? 0,
      pageSize: params.pageSize ?? 15,
    }
  );
  return response.data;
}
